"use client";

import { useAuth } from "@/features/auth/context/AuthContext";
import AdminTalentsList from "../components/AdminTalentsList";
import { PageHeader } from "@/components/common/PageHeader";
import PartnerTalentsList from "../components/PartnerTalentsList";
import SuperUserTalentsList from "../components/SuperUserTalentsList";
import { Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

const TalentsListContent = () => {
  const { profile } = useAuth();

  // Route to the appropriate component based on user role
  if (profile.isSuperUser) {
    return <SuperUserTalentsList />;
  }

  if (profile.role === "partner") {
    return <PartnerTalentsList />;
  }

  // Default fallback
  return <AdminTalentsList />;
};

export default function TalentList() {
  const { t } = useTranslation(["applications"]);
  return (
    <Fragment>
      <PageHeader
        breadcrumbs={[
          { title: t("breadcrumbs.home"), href: "/" },
          { title: t("breadcrumbs.talents") }
        ]}
      />
      <TalentsListContent />
    </Fragment>
  );
}
